// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"16":"select-avatar","86":"main-menu","238":"testing","774":"select-language"}[chunkId] || chunkId) + "-legacy." + {"16":"89cd7672","86":"6af20094","238":"0b38c43a","709":"cba1d2a3","774":"66c448d0"}[chunkId] + ".js";
};